import login from './login/index';

export default {
    login,
};